<template>
	<page>
		<module enable-flex>
			<!-- 视图化列表组件（work_type=5503 运营总后台商城订单） -->
			<view-list ref="view" :work-type="workType" :selector="true">
				<!-- 搜索栏 -->
				<template #search>
					<m-search ref="search">
						<m-search-item label="销售单号">
							<c-input name="order_no" maxlength="50" placeholder="请输入销售单号"></c-input>
						</m-search-item>
						<m-search-item label="背贴码">
							<c-input name="produce_code" maxlength="50" placeholder="请输入背贴码"></c-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<c-input name="imei" maxlength="50" placeholder="请输入IMEI"></c-input>
						</m-search-item>
						<m-search-item label="物流单号">
							<c-input name="delivery_no" maxlength="50" placeholder="请输入物流单号"></c-input>
						</m-search-item>
						<m-search-item label="销售渠道">
							<c-select name="channel_id" :options="channelOptions" value-key="id" label-key="channel_name" placeholder="请选择销售渠道"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<!-- 操作按钮区 -->
				<template #operate>
					<c-button v-if="auth('b_mall_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_mall_order_delivery')" color="main" prepend-icon="tf-add" @click="batchDeliveryHandle">批量生成发货单</c-button>
					<c-button v-if="auth('b_mall_order_light')" prepend-icon="tf-light" @click="lightControlHandle">灯控</c-button>
				</template>

				<!-- 操作列（固定右侧） -->
				<c-table-column type="button" label="操作" width="220" fixed="right" button-limit="6">
					<template #default="{data}">
						<c-table-button v-if="auth('b_mall_order_ship') && canShip(data)" icon="tf-deliver" @click="shipHandle(data)">发货</c-table-button>
						<c-table-button v-if="auth('b_mall_order_cancel') && canCancel(data)" icon="tf-cancel" @click="cancelHandle(data)">取消订单</c-table-button>
						<c-table-button v-if="auth('b_mall_order_more')" icon="tf-more" @click="moreHandle(data)">更多</c-table-button>
					</template>
				</c-table-column>

				<!-- 产品信息列：自定义渲染 -->
				<template #product_info="{data}">
					<div class="product-info">
						<div class="product-name">
							<span v-if="data.product_level" class="level-tag" :class="'level-' + levelClass(data.product_level)">{{ data.product_level }}</span>
							<span :title="data.product_name">{{ data.product_name || '-' }}</span>
						</div>
						<div class="product-code" v-if="data.produce_code">
							<span class="label">背贴码：</span>
							<span class="value">{{ data.produce_code }}</span>
						</div>
						<div class="product-code" v-if="data.imei">
							<span class="label">IMEI：</span>
							<span class="value">{{ data.imei }}</span>
						</div>
					</div>
				</template>

				<!-- 状态列：自定义渲染 -->
				<template #order_state="{data}">
					<span class="state-tag" :class="'state-' + data.order_state">{{ data.order_state_name || '-' }}</span>
				</template>

				<!-- 订单信息列：自定义渲染 -->
				<template #order_info="{data}">
					<div class="order-info">
						<div v-if="data.order_no">
							<span class="label">销售单号：</span>
							<span class="value">{{ data.order_no }}</span>
						</div>
						<div v-if="data.third_party_order_no">
							<span class="label">三方订单号：</span>
							<span class="value">{{ data.third_party_order_no }}</span>
						</div>
						<div v-if="data.third_party_quality_code">
							<span class="label">三方质检码：</span>
							<span class="value">{{ data.third_party_quality_code }}</span>
						</div>
					</div>
				</template>

				<!-- 销售价列：自定义渲染 -->
				<template #sale_price="{data}">
					<span v-if="data.sale_price">¥{{ data.sale_price }}</span>
					<span v-else>-</span>
				</template>

				<!-- 销售渠道列 -->
				<template #channel_name="{data}">
					<span>{{ data.channel_name || '-' }}</span>
				</template>

				<!-- 收货信息列：自定义渲染 -->
				<template #receiver_info="{data}">
					<div class="receiver-info">
						<div class="flex" v-if="data.receiver_name || data.receiver_phone">
							<span class="label">收货人：</span>
							<span class="value">{{ data.receiver_name }} {{ data.receiver_phone ? '(' + data.receiver_phone + ')' : '' }}</span>
						</div>
						<div class="flex" v-if="data.receiver_address">
							<span class="label">收货地址：</span>
							<span class="value" :title="data.receiver_address">{{ data.receiver_address }}</span>
						</div>
					</div>
				</template>

				<!-- 发货单号列 -->
				<template #delivery_no="{data}">
					<span>{{ data.delivery_no || data.express_no || '-' }}</span>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_mall_order',

		data() {
			return {
				/* 视图业务类型（550301=运营总后台商城订单，对应 TBL_SYS_WORK_TYPE.id） */
				workType: 550301,
				channelOptions: []
			}
		},

		mounted() {
			this.loadChannels();
		},

		methods: {
			/******加载销售渠道下拉选项******/
			loadChannels() {
				this.request({
					url: '/channel/options',
					data: {
						platform_code: 'XIAOHEI'
					},
					loading: false,
					success: data => {
						this.channelOptions = Array.from(data || [], item => {
							return {
								value: item.channel_id || item.id,
								name: item.channel_name || item.name
							}
						});
					}
				});
			},

			/******产品等级转样式类名******/
			levelClass(level) {
				const map = {
					'充新': 'chongxin',
					'靓机': 'liangji',
					'小花': 'xiaohua',
					'大花': 'dahua',
					'外爆': 'waibao',
					'内爆': 'neibao'
				};
				return map[level] || 'default';
			},

			/******批量生成发货单******/
			batchDeliveryHandle() {
				let rows = this.$refs.view.$refs.list.getData('selected') || [];
				if (!rows || rows.length === 0) {
					this.$message({
						message: '请选择要生成发货单的订单',
						type: 'warning'
					});
					return;
				}
				this.$message({
					message: '批量生成发货单功能开发中',
					type: 'info'
				});
			},

			/******灯控******/
			lightControlHandle() {
				this.$message({
					message: '灯控功能开发中',
					type: 'info'
				});
			},

			/******判断是否可以发货******/
			canShip(data) {
				return data.order_state === 2;
			},

			/******判断是否可以取消******/
			canCancel(data) {
				return data.order_state === 1 || data.order_state === 2;
			},

			/******发货******/
			shipHandle(data) {
				this.$message({
					message: '发货功能开发中',
					type: 'info'
				});
			},

			/******取消订单******/
			cancelHandle(data) {
				this.$confirm({
					message: '确认取消订单【' + data.order_no + '】？取消后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/mall/order/cancel',
							data: {
								order_id: data.order_id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '取消成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/******更多操作******/
			moreHandle(data) {
				this.$message({
					message: '更多功能开发中',
					type: 'info'
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.product-info
		padding: 6px 0
		line-height: 1.6

		.product-name
			display: flex
			align-items: center
			gap: 6px
			margin-bottom: 4px
			font-weight: 500

			span
				overflow: hidden
				text-overflow: ellipsis
				white-space: nowrap

		.product-code
			font-size: 12px
			color: #666

			.value
				color: #1890ff

	.order-info,
	.receiver-info
		padding: 6px 0
		line-height: 1.8
		font-size: 12px

		.label
			color: #999

		.value
			color: #333

	.receiver-info
		.value
			overflow: hidden
			text-overflow: ellipsis
			display: -webkit-box
			-webkit-line-clamp: 2
			-webkit-box-orient: vertical

	.state-tag
		display: inline-block
		padding: 2px 8px
		border-radius: 4px
		font-size: 12px
		line-height: 1.5

	.state-1
		background: #fff7e6
		color: #ff9900

	.state-2
		background: #fff7e6
		color: #ff9900

	.state-3
		background: #e6f7ff
		color: #1890ff

	.state-4
		background: #f6ffed
		color: #52c41a

	.state-5
		background: #f5f5f5
		color: #999999

	.level-tag
		display: inline-block
		padding: 1px 6px
		border-radius: 4px
		font-size: 12px
		line-height: 1.5
		margin-right: 6px
		flex-shrink: 0

	.level-chongxin
		background: #f6ffed
		color: #52c41a

	.level-liangji
		background: #e6f7ff
		color: #1890ff

	.level-xiaohua
		background: #fff0f6
		color: #eb2f96

	.level-dahua
		background: #fff7e6
		color: #ff9900

	.level-waibao,
	.level-neibao
		background: #fff1f0
		color: #ff4d4f

	.level-default
		background: #f5f5f5
		color: #666666
</style>
